<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout
    fluid
    column
    class="pa-0 ma-0 team-view"
    align-center
    justify-content
  >
    <page-title title="Team Management"></page-title>
    <v-flex class="team-header" v-if="$store.getters['user/details'].role === 'OWNER'">Team Management</v-flex>
    <v-flex class="team-header" v-if="$store.getters['user/details'].role !== 'OWNER'">You do not have access to this page.</v-flex>
    <v-flex class="team-table" v-if="$store.getters['user/details'].role === 'OWNER'">
      <div style="text-align: right;margin-bottom: 20px;">
        <v-btn
          class="add-user-btn"
          color="accent"
          medium
          depressed=""
          @click="showAddUserDialog"
        >
          Add User
        </v-btn>
      </div>
      <v-data-table
        :headers="headers"
        :items="userList"
        class="lg-table no-pagination"
        no-data-text=""
        :loading="loading"
        :pagination.sync="pagination"
        hide-actions

      >
        <template v-slot:items="props">
          <tr @click="selectUser(props.item)" class="user-item">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.role }}</td>
            <!-- <td>{{ props.item.status }}</td> -->
          </tr>
        </template>
        <template v-slot:no-data>
          <div class="list-empty">
            Your team list is empty. Please add your teammates here.
          </div>
        </template>
      </v-data-table>
    </v-flex>
    <SideNav
      v-model="userSideNav.model"
      @cancel="userSideNav.model = false"
      @save="saveUser"
      :title="userSideNavTitle"
      :actions="userSideNav.user.id"
    >
      <template v-slot:body>
        <v-layout fluid column style="max-width: 250px; height: auto">
          <v-flex class="text-input-container">
            <label> Name </label>
            <v-text-field
              class="lg-text-field"
              v-model="userSideNav.user.name"
              solo
              v-validate="'required|min:2|max:50'"
              :error-messages="errors.collect('Name')"
              data-vv-name="Name"
              counter="50"
            ></v-text-field>
          </v-flex>
          <v-flex class="text-input-container">
            <label> Email </label>
            <v-text-field
              class="lg-text-field"
              v-model="userSideNav.user.email"
              solo
              v-validate="'required|email|max:50'"
              :error-messages="errors.collect('Email')"
              data-vv-name="Email"
              counter="50"
              :disabled="userSideNav.user.id ? true : false"
            ></v-text-field>
          </v-flex>
          <v-flex class="text-input-container">
            <label>Role </label>
            <v-select
              class="lg-select role-select"
              :items="roleList"
              item-text="label"
              item-value="id"
              solo
              required
              v-validate="'required'"
              data-vv-name="Role"
              :error-messages="errors.collect('Role')"
              v-model="userSideNav.user.role"
              :disabled="userSideNav.user.id && userSideNav.user.role==='OWNER'"
            ></v-select>
          </v-flex>
          <v-btn
            color="accent"
            :disabled="userSideNavSaveBtnDisabled"
            medium
            depressed=""
            @click="saveUser"
            :loading="userSideNav.saveLoading"
            class="submit-button"
          >
            {{ userSideNavSaveBtnText }}
          </v-btn>
        </v-layout>
      </template>
      <template v-slot:actions >
        <LgDialog
          v-model="deleteDialog"
          :title="deleteUserDialogMessage.title"
          :content="deleteUserDialogMessage.message"
          primary-action-text="Delete"
          secondary-action-text="Cancel"
          :titleBg="colors.theme.warning"
          @primaryActionClick="deleteUser"
          @secondaryActionClick="deleteDialog = false"
          :primaryActionLoading="deleteUserLoading"
          :key="showDeleteButton"
        >
          <template v-slot:dactivator="{ on }">
            <img v-if="showDeleteButton"
            :key="showDeleteButton"
              class="delete-user-img"
              @click="deleteDialog = !deleteDialog"
              :src="require('@/assets/delete.svg')"
            />
          </template>
          <template v-slot:content>
            <v-container grid-list-md class="mt-2">
              {{deleteUserDialogMessage.message}}
              <v-layout wrap v-if="userSideNav.user.role === 'OWNER'" column>
                <v-flex class="text-input-container mt-4">
                  <label>Transfer ownership to </label>
                  <v-select
                    class="lg-select role-select"
                    :items="userList"
                    item-text="email"
                    item-value="id"
                    solo
                    required
                    v-validate="'required'"
                    data-vv-name="Role"
                    :error-messages="errors.collect('Role')"
                    v-model="userSideNav.user.role"
                    :disabled="userList.length <= 1"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-text-field 
                  :rules="[rules.required, rules.min]"
                  v-model="currentPassword" 
                  label="Current password" 
                  type="password"
                  required></v-text-field>
                </v-flex>
              </v-layout>  
            </v-container>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primaryLight4"
              outline
              @click="deleteDialog = !deleteDialog"
            >
              Cancel
            </v-btn>
            <v-btn
              color="warning"
              :loading="deleteUserLoading"
              depressed
              @click="deleteUser"
              :disabled="userSideNav.user.role === 'OWNER' && currentPassword.length < 8"
            >
              Delete
            </v-btn>
          </template>
        </LgDialog>
      </template>
    </SideNav>
  </v-layout>
</template>

<script>
import routes from '@/route_names'
import formMixins from '@/mixins/forms'
import userApi from '@/api/user'
import SideNav from '@/components/SideNav'
import LgDialog from '@/components/LgDialog'
export default {
  name: 'TeamView',
  mixins: [formMixins],
  components: { SideNav, LgDialog },
  mounted: function() {
    this.getUsers()
    console.log(this.colors)
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Email', value: 'email', align: 'center', sortable: false },
        { text: 'Role', value: 'role', align: 'center', sortable: false },
        // { text: 'Status', value: 'status', align: 'center', sortable: false }
      ],
      users: [],
      loading: true,
      userSideNav: {
        model: false,
        user: { name: '', email: '', role: null, id: null },
        saveLoading: false
      },
      pagination: {
        rowsPerPage: 20
      },
      deleteDialog: false,
      deleteUserLoading: false,
      authorizeDialog: true,
      currentPassword: '',
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
      }
    }
  },
  computed: {
    userList: function() {
      const vm = this
      return this.users.map(function(u) {
        
        return {
          id: u.id,
          name: u.name,
          email: u.username,
          role: u.role,
          status: u.disabled ? 'Disabled' : 'Active'
        }
      }).filter(function(u){
        return u.role !== 'OWNER'
      })
    },
    roleList() {
      const roles = [
        // { id: 'OWNER', label: 'Owner' },
        { id: 'ADMIN', label: 'Admin' },
        { id: 'GUEST', label: 'Guest' }
      ]
      if (this.userSideNav.user.role === 'OWNER') {
        roles.unshift({ id: 'OWNER', label: 'Owner' })
      }
      return roles
    },
    userSideNavTitle() {
      if (this.userSideNav.user.id) {
        return 'Edit User'
      } else {
        return 'Add User'
      }
    },
    userSideNavSaveBtnText() {
      if (this.userSideNav.user.id) {
        return 'Save'
      } else {
        return 'Send Invitation'
      }
    },
    userSideNavSaveBtnDisabled() {
      return !(this.isFormDirty && this.isFormValid)
    },
    showDeleteButton(){
        if(this.$store.getters['user/details'].username === this.userSideNav.user.email){
          return true
        }
        else if(this.roles[this.userSideNav.user.role].priority < this.roles[this.$store.getters['user/details'].role].priority){
          return true
        }
      
      return false
    },
    deleteUserDialogMessage(){
      
      return {
          title: 'Confirm user deletion',
          message: 'Please provide your current password to delete this user.'
        } 
    }
  },
  watch: {
    $route(to, from) {},
    addUserSideNav(newVal, oldVal) {
      console.log(newVal)
    }
  },
  methods: {
    getUsers() {
      const vm = this
      vm.loading = true
      userApi.getUsers().then(function(data) {
        vm.users = data.data.results
        vm.loading = false
      })
    },
    selectUser(user) {
      this.userSideNav.user = user
      this.userSideNav.model = true
      this.currentPassword = ''
      this.$nextTick(() => this.$validator.reset())
    },
    showAddUserDialog() {
      this.userSideNav.user = { name: null, email: null, role: null, id: null }
      this.userSideNav.model = true
      // this.$nextTick(() => this.$validator.reset())
    },
    saveUser() {
      const vm = this
      const u = {
        id: this.userSideNav.user.id,
        name: this.userSideNav.user.name,
        username: this.userSideNav.user.email,
        role: this.userSideNav.user.role
      }
      if (this.userSideNav.user.id) {
        userApi.updateUser(u).then(function(res) {
          vm.userSideNav.saveLoading = false
          vm.userSideNav.model = false
          vm.getUsers()
        })
      } else {
        userApi
          .addUser(u)
          .then(function(res) {
            vm.userSideNav.saveLoading = false
            vm.userSideNav.model = false
            vm.getUsers()
          })
          .catch(function(res) {
            res.response.data.errors.forEach(function(e) {
              if (e.field === 'username') {
                e.field = 'Email'
              }
              const field = vm.$validator.fields.find({
                name: e.field,
                scope: vm.$options.scope
              })
              if (!field) return

              vm.$validator.errors.add({
                id: field.id,
                field: e.field,
                msg: e.msg,
                scope: vm.$options.scope
              })

              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            })
          })
      }
    },
    deleteUser() {
      const vm = this
      vm.deleteUserLoading = true
      if(this.userSideNav.user.role === 'OWNER'){
          userApi.deleteAccount(this.userSideNav.user.id, this.currentPassword).then(function(res) {
            console.log(res)
            vm.deleteUserLoading = false
          })
      }
      else{
        userApi.deleteUser(this.userSideNav.user.id).then(function(res) {
        vm.userSideNav.deleteLoading = false
        vm.userSideNav.model = false
        vm.deleteDialog = false
        vm.getUsers()
        vm.deleteUserLoading = false
      })
      }
    }
  }
}
</script>

<style lang="stylus">
.team-view {
    width 100%
    .team-header {
        text-align center
        font-size 18px
        font-weight 500
        color: $color-primary-light-1
        max-height 50px
    }
    .team-table {
        width 800px
        text-align center
        .add-user-btn {
            margin 0
        }
        
    }
    .role-select  {
        .v-select__selections {
            text-align left !important
            justify-content: flex-start !important
        }
    }
    .user-item {
        cursor pointer
    }
    .submit-button {
        margin-top: 20px
    }
}

.delete-user-img {
    right: 10px;
    cursor pointer
    position: absolute;
}
</style>
